/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint react/jsx-one-expression-per-line: 0 */

import React from "react";
import styled from "styled-components";
import { Col, Row } from "react-bootstrap";

import {
  Carousel,
  Footer,
  NamedHeader,
  PageIntroKnaifel,
  SidesKnaifel,
  Spacer,
  Text,
  TopImage,
} from "../../../lib";

const { PUBLIC_URL } = process.env;

const Cover = styled.img`
  border: 1px solid #000;
  width: 50%;
`;

const Frame = styled.iframe`
  border: none;
  height: 450px;
  width: 100%;
`;

const Links = styled.div`
  position: sticky;
  top: 0px;
`;

const StyledTopImage = styled(TopImage)`
  margin-top: 30px;
`;

const Music: React.FC = () => (
  <>
    <NamedHeader name="музыка" />

    <PageIntroKnaifel author="knaifel" name="music" />

    <Spacer size={10} />

    <Carousel
      autoHeight
      slides={[{ url: `${PUBLIC_URL}/assets/images/knaifel/music/top.jpg` }]}
    />

    <Spacer size={10} />

    <SidesKnaifel hide="music">
      <Row>
        <Col lg={{ span: 8 }} sm={{ span: 8 }} xs={{ span: 8 }}>
          <Frame
            allow="clipboard-write"
            frameBorder="0"
            height="450"
            src="https://music.yandex.ru/iframe/album/35413752"
            style={{ border: "none", height: "450px", width: "100%" }}
            title="Yandex Music"
            width="100%"
          >
            Слушайте{" "}
            <a href="https://music.yandex.ru/album/35413752">
              Три степени свободы. Музыка &gt; Кино &gt; СССР. Александр
              Кнайфель (3)
            </a>{" "}
            —{" "}
            <a href="https://music.yandex.ru/artist/13511673">
              Александр Кнайфель
            </a>{" "}
            на Яндекс Музыке
          </Frame>
        </Col>

        <Col lg={{ span: 4 }} sm={{ span: 4 }} xs={{ span: 4 }}>
          <Links>
            <Text size={24}>
              <a
                href="https://music.apple.com/ru/album/%D1%82%D1%80%D0%B8-%D1%81%D1%82%D0%B5%D0%BF%D0%B5%D0%BD%D0%B8-%D1%81%D0%B2%D0%BE%D0%B1%D0%BE%D0%B4%D1%8B-%D0%BC%D1%83%D0%B7%D1%8B%D0%BA%D0%B0-%D0%BA%D0%B8%D0%BD%D0%BE-%D1%81%D1%81%D1%81%D1%80-%D0%B0%D0%BB%D0%B5%D0%BA%D1%81%D0%B0%D0%BD%D0%B4%D1%80-%D0%BA%D0%BD%D0%B0%D0%B9%D1%84%D0%B5%D0%BB%D1%8C-3/1822256330"
                rel="noreferrer"
                target="_blank"
              >
                Apple Music
              </a>
              <br />
              <a
                href="https://music.vk.com/link/bBOeQ"
                rel="noreferrer"
                target="_blank"
              >
                VK Музыка
              </a>
              <br />
              <a
                href="https://open.spotify.com/album/1QAUWRCuY8hAyOZTCjVjYZ"
                rel="noreferrer"
                target="_blank"
              >
                Spotify
              </a>
              <br />
              <a
                href="https://www.deezer.com/album/774549961"
                rel="noreferrer"
                target="_blank"
              >
                Deezer
              </a>
              <br />
            </Text>
          </Links>

          <Spacer size={10} />

          <a
            href="https://www.ozon.ru/product/vinilovaya-plastinka-aleksandr-knayfel-tri-stepeni-svobody-lp-2329612774/"
            rel="noreferrer"
            target="_blank"
          >
            <Cover
              src={`${PUBLIC_URL}/assets/images/knaifel/music/cover.jpg`}
            />
          </a>
          <Spacer size={2} />
          <a
            href="https://www.ozon.ru/product/vinilovaya-plastinka-aleksandr-knayfel-tri-stepeni-svobody-lp-2329612774/"
            rel="noreferrer"
            target="_blank"
          >
            <Text family="sans" size={18}>
              LP: предзаказ
            </Text>
          </a>
        </Col>
      </Row>
    </SidesKnaifel>

    <Spacer size={140} />

    <Footer />
  </>
);

export default Music;
